import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { BookstoreAvailabilityComponent } from './bookstore-availability.component';
import { BookstoreAvailabilityEffects } from './bookstore-availability.effects';
import { bookstoreAvailabilityReducer } from './bookstore-availability.reducer';
import {
  STATE_BOOKSTORE_AVAILABILITY,
  getInitialBookstoreAvailabilityState,
} from './bookstore-availability.state';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([BookstoreAvailabilityEffects]),
    StoreModule.forFeature(
      STATE_BOOKSTORE_AVAILABILITY,
      bookstoreAvailabilityReducer,
      {
        initialState: getInitialBookstoreAvailabilityState,
      },
    ),
  ],
  declarations: [BookstoreAvailabilityComponent],
  exports: [BookstoreAvailabilityComponent],
})
export class BookstoreAvailabilityModule {}
